import { Component, AfterViewInit, EventEmitter, Output, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import {
  NgbModal,
  ModalDismissReasons,
  NgbPanelChangeEvent,
  NgbCarouselConfig
} from '@ng-bootstrap/ng-bootstrap';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { RequestService } from '../../services/request.service';
import { ThemeService } from '../../services/theme.service';
declare var $: any;

@Component({
  selector: 'app-navigation',
  templateUrl: './navigation.component.html',
  styleUrls: ['./navigation.component.css']
})
export class NavigationComponent implements OnInit, AfterViewInit {
  @Output() toggleSidebar = new EventEmitter<void>();
  filter = "";
  public config: PerfectScrollbarConfigInterface = {};
  constructor(public router: Router, private modalService: NgbModal, public requestServ: RequestService, public themeService: ThemeService) { }
  ngOnInit(): void {
    this.cargarEmpresas();
  }

  // This is for Notifications

  empresas = []

  ngAfterViewInit() { }

  async cambiarEmpresa(empresa: number) {
    const response = await this.requestServ.cambiarEmpresa(empresa)
    if (response[0]) {
      if (this.router.url == '/dashboard') {
        await Promise.all([
          window.location.reload()
        ]);

      } else {
        this.router.navigateByUrl('/dashboard')
      }
    }



  }
  async cargarEmpresas() {
    const response = await this.requestServ.cargarEmpresas()
    if (response[0]) {
      this.empresas = response[1]
    }
  }
}

